<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else-if="log">
            <div class="card">
                <div class="card-header bg-white">
                    <h5 class="card-title">Ändringshistorik (20 senaste)</h5>
                </div>
                <div>
                    <table class="table table-xs">
                        <thead>
                            <tr>
                                <th>Datum</th>
                                <th>Användare</th>
                                <th>Ändringar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(l, l_index) in log" :key="'l-' + l_index">
                                <td>{{ formatDateTime(l.LogTS) }}</td>
                                <td>{{ (l.user ? l.user.FullName : '') }}</td>
                                <td v-html="l.LogAction.replace(/(?:\r\n|\r|\n)/g, '<br>')"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="text-danger">Kunde ej hämta data...</div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import { formatDateTime } from '@services/Helpers';

export default {
    name: 'ProductEditorLog',
    props: {
        id: {
            default: 'new',
        },
    },
    created() {
        this.getLog();
    },
    data: () => ({
        initialized: false,
        busy: true,
        log: [],
    }),
    methods: {
        formatDateTime,
        async getLog() {
            await apiClient.get('/vue/products/' + this.id + '/log')
                .then((response) => {
                    if (response.data) {
                        this.log = response.data;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
    },
};
</script>
